import React, { useState } from "react";
import Input from "../shared/form/Input";
import styles from "./Login.module.css";
import { Link, useNavigate } from "react-router-dom";
import logo_speed_order from '../images/SpeedOrderLogoSVG.svg'
import { Zap, QrCode, ChefHat } from "lucide-react";

import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import { navigateToArea, getArea } from "../shared/utils/subdomain";

function Login() {
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [mensagemErro, setMensagemErro] = useState("");
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_URL;
  const anoAtual = new Date().getFullYear();


  const efetuarLogin = async (e) => {
    e.preventDefault();
    setMensagemErro("");

    try {
      const response = await fetch(`${API_URL}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, senha }),
      });

      const data = await response.json();

      if (!response.ok) {
        setMensagemErro(data.mensagemErro || "Erro ao fazer login");
      } else {
        salvarDadosUsuario(data);
      }
    } catch (error) {
      setMensagemErro("Erro de conexão. Tente novamente.");
    }
  };

  const salvarDadosUsuario = (data) => {
    console.log("📦 [LOGIN] Dados recebidos do backend:", data);
    console.log("🔑 [LOGIN] Token recebido:", data.token ? "SIM" : "NÃO");

    localStorage.setItem("nome_usuario", data.nome);
    localStorage.setItem("nomeEstabelecimento", data.nomeEstabelecimento);
    localStorage.setItem("estabelecimento_id", data.id_estabelecimento);
    localStorage.setItem("tipo_usuario", data.tipo);

    // Função granular dentro da equipe (ex.: "atendente", "cozinha",
    // "entregador") — vem em data.tipo_usuario só pra login de Equipe.
    // Não reaproveita a chave "tipo_usuario" acima porque ela já guarda
    // data.tipo ("garcom"), usado pelo ProtectedRoute em todo o app.
    if (data.tipo === "garcom") {
      localStorage.setItem("funcao_equipe", data.tipo_usuario || "");
    } else {
      localStorage.removeItem("funcao_equipe");
    }

    // Atendente com vínculo em mais de um estabelecimento (mesmo email,
    // registros diferentes por loja) — guarda a lista pra Home da equipe
    // mostrar um seletor de qual atender agora.
    if (Array.isArray(data.estabelecimentos) && data.estabelecimentos.length > 1) {
      localStorage.setItem("equipe_estabelecimentos", JSON.stringify(data.estabelecimentos));
    } else {
      localStorage.removeItem("equipe_estabelecimentos");
    }

    // id_cliente só existe pra login de cliente — em login de admin/garçom, evita
    // gravar a string "undefined" (que quebra as checagens de id_cliente no checkout)
    if (data.id_cliente) {
      localStorage.setItem("id_cliente", data.id_cliente);
    } else {
      localStorage.removeItem("id_cliente");
    }

    // Disparar evento para conectar SSE ao estabelecimento
    if (data.id_estabelecimento) {
      window.dispatchEvent(new CustomEvent('estabelecimentoChanged', {
        detail: { estabelecimentoId: data.id_estabelecimento }
      }));
    }

    // Salvar id_universidade e nomeUniversidade (para cliente, admin e equipe)
    if (data.id_universidade) {
      localStorage.setItem("id_universidade", data.id_universidade);
      console.log("🎓 [LOGIN] id_universidade salvo:", data.id_universidade);
    } else {
      localStorage.removeItem("id_universidade");
    }

    if (data.nomeUniversidade) {
      localStorage.setItem("nomeUniversidade", data.nomeUniversidade);
      console.log("🎓 [LOGIN] nomeUniversidade salvo:", data.nomeUniversidade);
    } else {
      localStorage.removeItem("nomeUniversidade");
    }

    // Salvar admin_id se for administrador
    if (data.id_administrador) {
      localStorage.setItem("admin_id", data.id_administrador);

    }

    // Salvar id_funcionario se for funcionário/garçom
    if (data.id_funcionario) {
      localStorage.setItem("id_funcionario", data.id_funcionario);
      console.log("👤 [LOGIN] id_funcionario salvo:", data.id_funcionario);
    }

    // Armazenar JWT token
    if (data.token) {
      localStorage.setItem("token", data.token);
      console.log("✅ [LOGIN] Token salvo no localStorage");
      console.log("🔍 [LOGIN] Token salvo:", localStorage.getItem("token"));
    } else {
      console.error("❌ [LOGIN] ERRO: Token não foi recebido do backend!");
    }

    // Disparar evento customizado para atualizar contextos
    window.dispatchEvent(new Event('loginSuccess'));
    console.log("📢 [LOGIN] Evento 'loginSuccess' disparado");

    // Redirecionar baseado no tipo de usuário (troca de subdomínio se necessário)
    if (data.tipo === "administrador") {
      // Verificar se é master ou admin
      if (data.tipo_usuario === "master") {
        navigateToArea(navigate, "hub", "/speedhub/visaogeral");
      } else {
        navigateToArea(navigate, "admin", "/admin/gestaoestabelecimento");
      }
    } else if (data.tipo === "garcom") {
      if (data.tipo_usuario === "entregador") {
        navigateToArea(navigate, "operador", "/equipe/entregador/pedidos");
      } else {
        navigateToArea(navigate, "operador", "/equipe/home-equipe");
      }
    } else {
      // Se o cliente veio de um checkout interrompido (ex: escaneou QR sem estar logado),
      // volta pra lá em vez de mandar pra home.
      const redirectAfterLogin = localStorage.getItem('redirect_after_login');
      localStorage.removeItem('redirect_after_login');
      navigateToArea(navigate, "cliente", redirectAfterLogin || "/homecliente");
    }
  };

const loginComGoogle = async (credentialResponse) => {
  const response = await fetch(`${API_URL}/login-google`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token: credentialResponse.credential })
  });

  const data = await response.json();

  if (data.existe) {
    // Usuário já existe, faz login normal
    salvarDadosUsuario(data);
  } else {
    // Usuário novo, redireciona para cadastro
    localStorage.setItem("nome_usuario_google", data.nome);
    localStorage.setItem("email_google", data.email_institucional);
    localStorage.setItem("googleId", data.googleId);
    navigate("/cadastrocliente"); // Página onde ele preenche os outros dados
  }
};


  return (
    <main className={styles.page}>
      {/* Painel de marca — vira uma faixa compacta em telas estreitas */}
      <section className={styles.brandPanel}>
        <div className={styles.brandTexture} aria-hidden="true" />
        <div className={styles.brandGlowOne} aria-hidden="true" />
        <div className={styles.brandGlowTwo} aria-hidden="true" />

        <div className={styles.brandContent}>
          <div className={styles.brandBadge}>
            <img src={logo_speed_order} alt="" />
          </div>

          <h1 className={styles.brandHeadline}>
            Peça mais rápido.<br />Aproveite mais o momento.
          </h1>
          <p className={styles.brandSub}>
            Do pedido na mesa até a cozinha, tudo conectado em um só lugar —
            sem fila, sem espera, sem complicação.
          </p>

          <ul className={styles.brandFeatures}>
            <li>
              <span className={styles.brandFeatureIcon}><Zap size={16} /></span>
              Pedidos prontos em segundos, direto do celular
            </li>
            <li>
              <span className={styles.brandFeatureIcon}><QrCode size={16} /></span>
              Escaneie o QR Code da mesa e comece a pedir
            </li>
            <li>
              <span className={styles.brandFeatureIcon}><ChefHat size={16} /></span>
              Cozinha, garçom e cliente sempre sincronizados
            </li>
          </ul>
        </div>

        <span className={styles.brandFooter}>© {anoAtual} SpeedOrder — parte do ecossistema UniEat</span>
      </section>

      {/* Painel do formulário */}
      <section className={styles.formPanel}>
        <div className={styles.secaoform}>
          <div className={styles.wrapper}>
            <img src={logo_speed_order} alt="Logo SpeedOrder" className={styles.mobileLogo} />

            <form className={styles.form} onSubmit={efetuarLogin}>
              <h2>Login</h2>
              <h3>Bem-vindo de volta! Entre com sua conta.</h3>

              {mensagemErro && (
                <div className={styles.mensagemErro}>
                  {mensagemErro}
                </div>
              )}

              <Input
                type="email"
                text="Digite seu email: "
                name="email"
                placeholder="Entre com seu email"
                handleOnChange={(e) => setEmail(e.target.value)}
                icon="✉"
              />
              <Input
                type="password"
                text="Digite sua senha: "
                name="senha"
                placeholder="Digite sua senha"
                handleOnChange={(e) => setSenha(e.target.value)}
                icon="🔒"
              />

              <div className={styles.linksContainer}>
                <p className={styles.esqueceuasenhap}>
                  <Link to="/recuperarsenha">Esqueceu a senha?</Link>
                </p>
              </div>

              <button className={styles.btnLogin} type="submit">Entrar</button>

              {/* Divisor */}
              <div className={styles.divider}>Ou escolha outro método de acesso</div>

              {/* Botão do Google */}
              <div className={styles.googleButtonContainer}>
                <GoogleLogin
                  onSuccess={loginComGoogle}
                  onError={() => {
                    console.log("Erro no login com Google");
                  }}
                />
              </div>

              {getArea() !== 'operador' && (
                <p className={styles.criarconta}>
                Ainda não usa o Unieat?
                <br />
                Criar conta como:
                <br />
                <Link to="/cadastroadmin">Estabelecimento</Link> ou{" "}
                <Link to="/cadastrocliente">Cliente</Link>

                </p>
              )}
            </form>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Login;
